<template>
  <div class="common-card">
    <modal-product-filter 
      :productCategories="productCategories"
      :productStatuses="productStatuses"
      :productCategoryFilter.sync="productCategoryFilter"
      :productStatusFilter.sync="productStatusFilter"
      @refetch-data="refetchData"
    />
    <b-card class="top mb-0">
      <div class="d-flex flex-wrap align-items-center justify-content-between">
        <div class="d-flex mb-1 mb-sm-0 align-items-center">
          <h4 class="font-weight-bolder ml-1 text-nowrap mb-0">
            <font-awesome-icon
              class="mr-50"
              icon="fa-solid fa-people-carry-box"
            />
            商品管理
          </h4>
          <div class="d-flex ml-3 align-items-center">
            <label>顯示</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>條目</label>
          </div>
        </div>
        <div class="d-flex mobile-w100 flex-wrap mt-1 mt-lg-0">
          <b-form-input
            v-model="searchQuery"
            class="search-form mb-1 mb-sm-0 mr-sm-1"
            placeholder="搜尋"
          />
          <b-button
            variant="primary"
            class="mr-sm-1 mobile-w100 mb-1 mb-sm-0"
            @click="$bvModal.show('modal-product-filter')"
            ><feather-icon
              class="mr-1"
              icon="filterIcon"
              size="18"
            ></feather-icon
            >篩選</b-button
          >
          <b-button class="mobile-w100" :to="{ name: 'product-create' }" v-if="ability.can('create', 'products')">
            <feather-icon class="mr-1" icon="plusIcon" size="18"></feather-icon
            >新增商品</b-button
          >
        </div>
      </div>
    </b-card>

    <b-card no-body class="card-statistics bottom">
      <b-card-body class="p-2">
        <b-table
          ref="refProductListTable"
          class="position-relative"
          :items="fetchProducts"
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="未找到匹配的記錄"
          :sort-desc.sync="isSortDirDesc"
        >
          <!-- Column: product_status -->
          <template #cell(product_status_id)="data">
            {{ getProductStatus(data.item.product_status_id) }}
          </template>

          <template #cell(quantity)="data">
            {{ parseFloat(Number(data.item.quantity).toString()) }}
          </template>

          <!-- Column: product_category -->
          <template #cell(product_category_id)="data">
            {{ getProductCategory(data.item.product_category_id) }}
          </template>

          <!-- Column: product_unit -->
          <template #cell(product_unit)="data">
            {{ data.item.product_unit && data.item.product_unit.name  }}
          </template>

          <template #cell(created_at)="data">
            {{ getDateTime(data.item.created_at) }}
          </template>

          <template #cell(actions)="data">
            <b-dropdown
              :class="`action-trigger-btn ${
                productsList.length <= 3 ? 'hor' : 'ver'
              }`"
              :right="$store.state.appConfig.isRTL"
            >
              <template #button-content>
                <feather-icon
                  icon="EyeIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>

              <!-- <b-dropdown-item
                v-if="ability.can('read', 'product') || true"
                :to="{
                  name: 'product-view',
                  params: { id: data.item.id },
                }"
              >
                <feather-icon icon="FileTextIcon" />
                <span class="align-middle ml-50">詳細資料</span>
              </b-dropdown-item> -->

              <b-dropdown-item
                v-if="ability.can('update', 'products')"
                :to="{
                  name: 'product-edit',
                  params: { id: data.item.id },
                }"
              >
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">修改資料</span>
              </b-dropdown-item>

              <b-dropdown-item
                v-if="ability.can('delete', 'products')"
                @click="removeItem(data.item.id)"
              >
                <feather-icon icon="Trash2Icon" />
                <span class="align-middle ml-50">刪除資料</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >在{{ dataMeta.of }}個記錄中，正在顯示 {{ dataMeta.from }} 至
                {{ dataMeta.to }}個記錄</span
              >
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRow"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>
    
<script>
import {
  BCard,
  BCardBody,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { ref, onUnmounted } from "@vue/composition-api";
import useProductsList from "./useProductsList";
import productStoreModule from "../productStoreModule";
import ModalProductFilter from "../modal/ModalProductFilter.vue";
export default {
  components: {
    BCard,
    BCardBody,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
    ModalProductFilter
  },
  data() {
    return {};
  },
  methods: {
    removeItem(id) {
      this.$swal({
        title: "你確定嗎?",
        text: "您的決定是最終決定，您將無法取回這記錄。",
        showCancelButton: true,
        confirmButtonText: "刪除",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("product/deleteProduct", { id })
            .then((response) => {
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.refetchData();
            })
            .catch((error) => {
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },

    getProductStatus(statusId) {
      if (!statusId || !this.productStatuses || !this.productStatuses.length) {
        return '';
      }
      const status = this.productStatuses.find(function(ele) {
        return ele.id === statusId;
      });
      return status ? status.name : '';
    },

    getProductCategory(categoryId) {
      if (!categoryId || !this.productCategories || !this.productCategories.length) {
        return '';
      }
      const category = this.productCategories.find(function(ele) {
        return ele.id === categoryId;
      });
      return category ? category.name : '';
    },

    getProductUnit(unitId) {
      if (!unitId || !this.productUnits || !this.productUnits.length) {
        return '';
      }
      const unit = this.productUnits.find(function(ele) {
        return ele.id === unitId;
      });
      return unit ? unit.name : '';
    },
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = "product";

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
      store.registerModule(USER_APP_STORE_MODULE_NAME, productStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME))
        store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    });

    const {
      fetchProducts,
      tableColumns,
      perPage,
      currentPage,
      totalRow,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      productsList,
      refProductListTable,
      refetchData,
      ability,
      refetchOption,
      productStatuses,
      productCategories,
      productStatusFilter,
      productCategoryFilter,
    } = useProductsList();

    return {
      fetchProducts,
      tableColumns,
      perPage,
      currentPage,
      totalRow,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      productsList,
      refProductListTable,
      refetchData,
      ability,
      refetchOption,
      productStatuses,
      productCategories,
      productStatusFilter,
      productCategoryFilter,
    };
  },
};
</script>
    
<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

// @media screen and (max-width: 768px) {

// }
// @media screen and (max-width: 575px) {

// }
</style>
    
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@/assets/scss/variables/_variables.scss";
</style>
    